export const OperationalStates = {
  UNKNOWN: 'unknown',
  ENABLED: 'enabled',
  ENABLING: 'enabling',
  DISABLED: 'disabled',
  DISABLING: 'disabling',
  ERROR: 'error'
};

export const OperationalStateMessages = {
  [OperationalStates.ENABLED]: 'Service Enabled',
  [OperationalStates.ENABLING]: 'Enabling Service',
  [OperationalStates.DISABLED]: 'Service Disabled',
  [OperationalStates.DISABLING]: 'Disabling Service'
};

export function getOperationalState(serviceInfo = {}) {
  // update-req can be "idle", "in-service-request", "out-of-service-request", etc.
  // update-rsp can be "idle", "in-service-pending", "out-of-service-pending", etc.
  if (serviceInfo['update-req'] === 'idle' && serviceInfo['update-rsp'] === 'idle') {
    // update-status-code can be standby, in-service-okay, in-service-fail, etc.
    if (serviceInfo['update-status-code'].endsWith('fail')) {
      return OperationalStates.ERROR;
    }

    // operational-state can be "disabled", "enabled" or ""
    return serviceInfo['operational-state'] || OperationalStates.UNKNOWN;
  }

  if (serviceInfo['update-req'] === 'in-service-request' && serviceInfo['update-rsp'] === 'in-service-pending') {
    return OperationalStates.ENABLING;
  }

  if (
    serviceInfo['update-req'] === 'out-of-service-request' &&
    serviceInfo['update-rsp'] === 'out-of-service-pending'
  ) {
    return OperationalStates.DISABLING;
  }

  return OperationalStates.UNKNOWN;
}

export function getOperationalStateProgress(serviceInfo = {}) {
  return serviceInfo['update-progress'] || 0;
}
